import HtmlToReact from 'html-to-react';

const HtmlToReactParser = HtmlToReact.Parser;
const htmlToReactParser = new HtmlToReactParser();

const isValidNode = () => true;

const TemplateParser = (props) => {
  const { product, start, end } = props;

  const firstImage = (start && parseInt(start, 10)) || 1;
  const lastImage = (end && parseInt(end, 10)) || product.images.length;
  const imageArray = product.images.slice(firstImage - 1, lastImage);
  return imageArray.map((image, index) =>
    htmlToReactParser.parseWithInstructions(
      props.children,
      isValidNode,
      props.processingImages(product, index + firstImage - 1)
    )
  );
};

export default TemplateParser;
